import {RESOURCE_TYPE_SINGULAR} from './Policy.types'

export enum ShadowITViews {
  application = 'application',
  location = 'location',
}

export interface ShadowITResponse {
  // either apps or location going to come from API
  apps?: ShadowITEntity[]
  locations?: ShadowITEntity[]
  date: string
}

export interface TopActivityUser {
  name: string
  email: string
  user?: string
  dataConsumed?: number
  dataSent?: number
  noOfTransactions?: number
}

export interface ShadowITEntity {
  name: string
  dataConsumed?: number
  dataSent?: number
  noOfUsers: number
  users?: TopActivityUser[]
}

export interface ShadowITRequest {
  params?: AnalyticsSearchQueryParams
}

export interface ShadowITFilter {
  searchTerm: string
  searchDisplayValue: string
  searchType: RESOURCE_TYPE_SINGULAR
}

export type ShadowITAppTab = 'all' | 'corporate' | 'personal'
export type ShadowITLoginType = 'all' | 'accepted' | 'unaccepted'

export interface AnalyticsSearchQueryParams {
  search: string
  search_type: RESOURCE_TYPE_SINGULAR
}

export enum DataAttributeName {
  dataSent = 'dataSent',
  dataConsumed = 'dataConsumed',
}

export interface GetShadowITUserState {
  appName: string
  logins?: ShadowUserLogin[]
  totalAppVolumeInBytes?: number
}

export interface GetAnalyticsUserVolume {
  appName: string
  totalAppVolumeInBytes: number
}

export interface GetShadowFinderUserLoginsResponse {
  data: GetShadowFinderUserLoginsData
  // handle errors later
}

export interface GetShadowFinderUserLoginsData {
  apps: GetShadowFinderUserLogin[]
}

export interface GetShadowFinderUserLogin {
  appName: string
  logins: ShadowUserLogin[]
}

export interface Context {
  primaryId: string
  secondaryId: string
}
export interface ShadowUserLogin {
  email: string
  isAcceptedDomain: boolean
  contexts: Context[]
}

export interface PageInfo {
  endCursor: string
  hasNextPage: boolean
}
export interface NumOfUsers {
  loginWithAcceptedDomains: number
  loginWithUnacceptedDomains: number
}
export interface Summary {
  numOfUsers: NumOfUsers
}

export interface GetShadowITAppUsers {
  appName: string
  users: ShadowItUsersType[]
  pageInfo: PageInfo
  summary?: Summary
}

export interface GetShadowITAppUsersRes {
  data: GetShadowITAppUsers
}

export interface ShadowItVolumesType {
  userId: string
  totalUserVolumeInBytes: number
}

export interface ShadowItUsersType {
  userId: string
  logins?: ShadowUserLogin[]
}

export interface GetShadowITAppVolumes {
  appName?: string
  userVolumes: ShadowItVolumesType[]
  pageInfo: PageInfo
}

export interface ShadowItAppViewMerged {
  userId: string
  logins?: ShadowUserLogin[]
  totalUserVolumeInBytes?: number
}

export interface ShadowITAppQueryState {
  appName: string
  users: ShadowItUsersType[]
  volumes: ShadowItVolumesType[]
  mergedUsersAndVolumes: ShadowItAppViewMerged[]
  usersPageInfo?: PageInfo
  volumesPageInfo?: PageInfo
  userSummary?: Summary
}

export interface ShadowITOverviewVolumesResponse {
  data: ShadowITOverviewVolumesData
}

export interface ShadowITOverviewVolumesData {
  apps: ShadowITOverviewVolumesByApp[]
}

export interface ShadowITOverviewVolumesByApp {
  appName: string
  noOfUsers: number
  totalAppVolumeInBytes: number
}

export interface ShadowITOverviewLoginsResponse {
  data: ShadowITOverviewLoginsData
}

export interface ShadowITOverviewLoginsData {
  apps: ShadowITOverviewLoginsByApp[]
}

export interface ShadowITOverviewLoginsByApp {
  appName: string
  numOfUsers: ShadowFinderNumOfUsers
}

export interface ShadowFinderNumOfUsers {
  totalUsers: number
  loginWithAcceptedDomains: number
  loginWithUnacceptedDomains: number
}

export interface ShadowViewTopItem {
  name: string
  noOfUsers: number
  totalAppVolumeInBytes: number
  numOfUsers: ShadowFinderNumOfUsers
}
